/* eslint one-var: [0]*/

import Utils from '../utils/utils.js';
import Api from '../utils/api.js';

const api = new Api();

export default class DayEventsList {
	init( result ){
		if ( typeof result === 'undefined' ){
			api.getAllDays().then( ( _result ) => {
				this.append( _result );
				this.initEvents();
			} );
		} else {
			this.append( result );
			this.initEvents();
		}
	}
  
	initEvents(){
		const prevNextItems = ( event, data ) => {
			let $target;
			let scope;

			if ( event.type === 'click' ) {
				$target = jQuery( event.target );
				scope = $target.data( 'eventListScope' );
			} else {
				$target = jQuery( '.c-events-teaser__filter > a' );
				scope = Utils.isset( data ) ? data : $( '#c-event-highlights__filter-select' ).val();
			}

			$target.attr( 'disabled', true );
			Utils.progressBar( 'start' );

			api.getDayEventsList( scope ).then( ( res ) => {
				Utils.progressBar( 'stop' );
				$target.removeAttr( 'disabled' );
				
				if ( res !== false && res.length !== 0 ){
					this.changeEvents( scope, res.rendered );
				}
			} );	

			event.preventDefault();
		};

		$( document ).on( 'oax::event-teaser-next-prev', prevNextItems );
		this.$chooser.on( 'click.oax::event-teaser-next-prev', 'a', prevNextItems );
	}
  
	append( days ){
		const $container = jQuery( '.c-event-teaser-list' ),
			$header = $container.find( 'h2:first' ),
			$dayEventsChooser = jQuery( '<div class="c-events-teaser__filter inline text-sm pl-05"></div>' ),
			currentDate = Utils.getCurrentDate(),
			_currentDate = new Date( currentDate ),
			dayArr = [];

		let prevDate = null, 
			nextDate = null;

		for ( let i = 0; i < days.length; i++ ){
			const day = days[i];
			dayArr.push( day.scope );
		}

		const currentDayIndex = dayArr.indexOf( currentDate );

		if ( currentDayIndex !== -1 ){
			prevDate = typeof dayArr[currentDayIndex - 1] !== 'undefined' ? dayArr[currentDayIndex - 1] : dayArr[dayArr.length - 1];
			nextDate = typeof dayArr[currentDayIndex + 1] !== 'undefined' ? dayArr[currentDayIndex + 1] : dayArr[0];
		} else {
			prevDate = dayArr[dayArr.length - 1];
			nextDate = dayArr[1];
		}

		$dayEventsChooser.append( `<a href="${OAX.config.url_base}${OAX.config.url_path_tagesprogramm}/${prevDate}" class="no-underline px-05 inline-block no-barba" data-event-list-scope="${prevDate}">&lt;</a>` );
		$dayEventsChooser.append( `<a href="${OAX.config.url_base}${OAX.config.url_path_tagesprogramm}/${nextDate}" class="no-underline px-05 inline-block no-barba" data-event-list-scope="${nextDate}">&gt;</a>` );
		$header.append( $dayEventsChooser );

		this.dayArr = dayArr;
		this.$container = $container;
		this.$header = $header;
		this.$chooser = $dayEventsChooser;

		this.$table = jQuery( '.c-events-table__wrapper' );
		this.$table_body = this.$table.find( '.c-events-table__body' );
		if ( this.$table_body.find( '.c-events-table__row' ).length < 5 ){
			for ( let i = this.$table_body.find( '.c-events-table__row' ).length; i < 5; i++ ){
				this.$table_body.append( '<div class="c-events-table__row clearfix" role="row"></div>' );
			}
		}		
	}

	changeEvents( currentScope, template ){
		const self = this;
		const headerTxt = jQuery( template ).find( 'h2:first span' ).text(),
			$listItems = jQuery( template ).find( '.c-events-table__body .c-events-table__row' ),
			currentDayIndex = this.dayArr.indexOf( currentScope );

		let prevDate = null,
			nextDate = null;

		if ( currentDayIndex !== -1 ){
			prevDate = typeof this.dayArr[currentDayIndex - 1] !== 'undefined' ? this.dayArr[currentDayIndex - 1] : this.dayArr[this.dayArr.length - 1];
			nextDate = typeof this.dayArr[currentDayIndex + 1] !== 'undefined' ? this.dayArr[currentDayIndex + 1] : this.dayArr[0];
		} else {
			prevDate = this.dayArr[this.dayArr.length - 1];
			nextDate = this.dayArr[1];
		}			

		// change title
		this.$header.find( 'span' ).text( headerTxt );

		// change links
		this.$chooser.find( 'a:first' ).attr( 'data-event-list-scope', prevDate ).data( 'eventListScope', prevDate ).attr( 'href', `${OAX.config.url_base}${OAX.config.url_path_tagesprogramm}/${prevDate}` );
		this.$chooser.find( 'a:last' ).attr( 'data-event-list-scope', nextDate ).data( 'eventListScope', nextDate ).attr( 'href', `${OAX.config.url_base}${OAX.config.url_path_tagesprogramm}/${nextDate}` );
		
		/*
		 * animate out items and remove them.
		 * then add the new items from $listItems
		 * to the table and animate them in
		 */
		gsap.set( $listItems, {
			autoAlpha: 0
		} );
		const selectorTableWrapperRows = '.c-events-table__row';

		gsap.to( this.$table_body.find( selectorTableWrapperRows ), {
			duration: 0.5,
			opacity: 0,
			stagger: 0.05,
			onComplete(){
				self.$table_body.empty();				
				self.$table_body.append( $listItems );
				gsap.to( self.$table_body.find( selectorTableWrapperRows ), {
					duration: 0.5,
					autoAlpha: 1,
					stagger: 0.05
				} );
			}
		} );

		// change more btn
		jQuery( '.c-event-teaser-list__more' ).attr( 'href', `${OAX.config.url_base}${OAX.config.url_path_tagesprogramm}/${currentScope}` );    
	}
}
